<template>
    <!-- Announces the new page title on client-side navigation, which is
         otherwise silent to screen readers. Nuxt's built-in app.vue already
         renders one, but inside <NuxtLayout>'s slot — and the layouts here
         render <NuxtPage> themselves and never render that slot, so it never
         appeared. -->
    <NuxtRouteAnnouncer />
    <NuxtLayout />
</template>

<style>
    /* <main> takes focus from the skip link (tabindex="-1" in the layouts),
       which is a programmatic jump, not a control — no focus ring around the
       whole page. */
    main[tabindex='-1']:focus {
        outline: none;
    }
</style>
